export default "__VITE_ASSET__CaHWBTNi__"